import { render, staticRenderFns } from "./ArticleContents2.vue?vue&type=template&id=526e564e&"
import script from "./ArticleContents2.vue?vue&type=script&lang=js&"
export * from "./ArticleContents2.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContents2.vue?vue&type=style&index=0&id=526e564e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports